<template>
  <div id="app">
    <!-- <div :style="{height:(44 + $store.state.base.user.navHeight)+'px'}" ></div> -->
    <!-- <keep-alive> -->
      <router-view :key="$route.fullPath"></router-view>
    <!-- </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      matomoIntervalId: null,
    };
  },
  // mounted ()  {
  
  // },
  mounted () {
    let _this = this
    this.setIsMobile()
    window.addEventListener('resize', function () {
      _this.setIsMobile()
    }, { passive: true })

    const scriptDom = document.createElement('script')
    scriptDom.src = '/js/statistics.js'
    scriptDom.defer = true
    document?.head?.appendChild(scriptDom)
    scriptDom.onload = () => {
      this.checkMatomo(() => {
        window?.matomoQueue?.forEach((i) => {
          window?._paq?.push(i) // matomo初始化完成后，上报队列中需要埋点的数据
        })
        window.matomoQueue = []
      })
    }
  },
  beforeDestroy () {
    if (this.matomoIntervalId) {
      clearInterval(this.matomoIntervalId)
      this.matomoIntervalId = null
    }
  },
  methods: {
    // 检查matomo是否加载完成
    checkMatomo (callback = () => {}) {
      const tryInvoke = () => {
        if (window?.Matomo) {
          if (this.matomoIntervalId) {
            clearInterval(this.matomoIntervalId)
            this.matomoIntervalId = null
          }
          callback()
        }
      }
      // 先立即尝试一次，避免不必要的等待
      tryInvoke()
      // 如未就绪则开始轮询
      if (!window?.Matomo && !this.matomoIntervalId) {
        this.matomoIntervalId = setInterval(tryInvoke, 1000)
      }
    },
    setIsMobile () {
      if (document.documentElement.clientWidth > (799 - this.getScrollbarWidth())) {
        this.$store.commit('base/setMobile', false)
      } else {
        this.$store.commit('base/setMobile', true)
      }
    },
    getScrollbarWidth () { // 计算滚动条宽度
      const scrollDiv = document.createElement('div')
      scrollDiv.style.cssText = 'height: 99px; overflow: scroll; position: absolute; top: -9999px;'
      document.body.appendChild(scrollDiv)
      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      document.body.removeChild(scrollDiv)
      return scrollbarWidth
    },
  },
};
</script>


